import { useContext } from "react";
import { AppContext } from "../App";
import ServicesLanding from "../views/ServicesLanding";
import Audit from "../views/Audit";
import Account from "../views/Accounting";
import Tax from "../views/Tax";
import Advisory from "../views/Advisory"

export default function Services() {
  const appContext = useContext(AppContext);

  if (
        (!appContext.navSubItem || appContext.navSubItem === "audit") &&
        !appContext.navExtraItem &&
        !appContext.navMoreItem
      ) {
        return <Audit />;
      }
    
      if (
        appContext.navSubItem === "accounting" &&
        !appContext.navExtraItem &&
        !appContext.navMoreItem
      ) {
        return <Account />;
      }

      if (
        appContext.navSubItem === "advisory" &&
        !appContext.navExtraItem &&
        !appContext.navMoreItem
      ) {
        return <Account />;
      }

      if (
        appContext.navSubItem === "tax" &&
        !appContext.navExtraItem &&
        !appContext.navMoreItem
      ) {
        return <Tax />;
      }
      
    return <ServicesLanding />;
}

